// Full dress color palette. Which of these are offered on the try-on page is
// controlled by the admin via settings.setAvailableColors.
export const TRYON_COLORS: { name: string; hex: string }[] = [
  { name: "Black", hex: "#2b2b2b" },
  { name: "White", hex: "#f7f5f0" },
  { name: "Red", hex: "#c0392b" },
  { name: "Emerald", hex: "#2e8b6a" },
  { name: "Navy", hex: "#2c3e63" },
  { name: "Blush Pink", hex: "#e8b4c0" },
  { name: "Lavender", hex: "#b3a3d4" },
  { name: "Champagne", hex: "#e6d3b3" },
];
